import { authStorage } from "../../utils/storage";

export const refreshAccessToken = async (): Promise<string | null> => {
  const refreshToken = authStorage.getRefreshToken();
  if (!refreshToken) return null;

  try {
    const res = await fetch("/api/auth/refresh", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
    });

    if (!res.ok) return null;

    const { accessToken } = await res.json();
    authStorage.setAccessToken(accessToken);
    return accessToken;
  } catch {
    return null;
  }
};
